module.exports = __webpack_public_path__ + "img/icon_testflight.1d22cc9c.png";